import { AxiosResponse } from 'axios'
import { environments } from 'environments/environments'
import { ResponsibleSchemaForm } from 'pages/Institution/components/Responsible/interfaces'
import api from './api'

const { ENDPOINT_API_INSTITUTIONS } = environments

interface PayloadEditResponsible {
    idInstitution: string
    data: ResponsibleSchemaForm
    idResponsible: string
}

export const createResponsible = async (
    idInstitution: string,
    data: ResponsibleSchemaForm
): Promise<AxiosResponse<any>> => {
    return api.post(
        `${ENDPOINT_API_INSTITUTIONS}/instituicoes-financeiras/${idInstitution}/responsaveis`,
        data
    )
}

export const editResponsible = async ({
    idInstitution,
    data,
    idResponsible
}: PayloadEditResponsible): Promise<AxiosResponse<any>> => {
    return api.put(
        `${ENDPOINT_API_INSTITUTIONS}/instituicoes-financeiras/${idInstitution}/responsaveis/${idResponsible}`,
        data
    )
}

export const deleteResponsible = async (
    idInstitution: string,
    idResponsible: string
): Promise<AxiosResponse<void>> => {
    return await api.delete(
        `${ENDPOINT_API_INSTITUTIONS}/instituicoes-financeiras/${idInstitution}/responsaveis/${idResponsible}`
    )
}
